// extracted by mini-css-extract-plugin
export default {"truncatedCell":"cellRenderer__truncatedCell--ljXWLP_PHQQ1juGnt9TG"};